"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReviewScore = exports.scores = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const web_1 = require("@react-spring/web");
const imageSrcBaseUrl = 'https://meucatalogodigitalresources.grupoboticario.digital/assets/review/';
const getScoreImage = (score) => `${imageSrcBaseUrl}score_${score}.png`;
exports.scores = [
    {
        score: 1,
        label: 'Péssima',
    },
    {
        score: 2,
        label: 'Não gostei',
    },
    {
        score: 3,
        label: 'Neutro',
    },
    {
        score: 4,
        label: 'Gostei',
    },
    {
        score: 5,
        label: 'Amei',
    },
];
const scoreImages = exports.scores.map(({ label, score }) => ((0, jsx_runtime_1.jsx)(flora_react_1.Image, { alt: label, width: 28, height: 28, src: getScoreImage(score) }, label)));
/**
 * Componente para selecionar uma nota de avaliação da compra
 *
 * @param {function} onClick - função chamada quando uma nota é clicada
 * @param {number | null | undefined} preSelectedScore - valor pré-selecionado da nota: 1 a 5
 * @returns {JSX.Element}
 */
const OrderReviewScore = ({ onClick, selectedScore }) => {
    const trails = (0, web_1.useTrail)(scoreImages.length, {
        from: { transform: 'translateY(-100%)', opacity: 0 },
        to: { transform: 'translateY(0%)', opacity: 1 },
    });
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({ align: "start", justify: "space-between", css: { width: '100%', paddingTop: '$4', paddingBottom: '$4' } }, { children: trails.map((props, index) => {
            const { score, label } = exports.scores[index];
            return ((0, jsx_runtime_1.jsx)(web_1.animated.div, Object.assign({ style: props }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ variant: "unstyled", "aria-pressed": selectedScore === score, "aria-label": label, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick({ score, label }), css: { height: 'auto' } }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ gap: 4, direction: "column", align: "center", justify: "start", css: {
                            width: '55px',
                            whiteSpace: 'break-spaces',
                            cursor: 'pointer',
                            opacity: selectedScore === score ? 1 : 0.5,
                            userSelect: 'none',
                            '&:hover': {
                                transform: 'scale(1.1)',
                            },
                        } }, { children: [scoreImages[score - 1], (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ as: "p", size: "exceptionsAuxiliarRegular", align: "center" }, { children: label }))] })) })) }), score));
        }) })));
};
exports.OrderReviewScore = OrderReviewScore;
